import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {Cached,Map as MapI,LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel,FilterList, FormatListNumbered,ConfirmationNumber,HourglassEmpty,Check,Close} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid,
  Slide,Link
} from "@material-ui/core";

import Format from "date-fns/format";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import {useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService,ReportingService,AdminService,FinanceService,groupBy} from "./../../utils/web_config_2";


import UserInfo from "./login_info";

import DateFnsUtils from "@date-io/date-fns";

import axios from 'axios';

import Chart from 'react-apexcharts'

import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { format } from "date-fns/esm";

import { Map, Marker, Popup, TileLayer } from "react-leaflet";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},
paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height:300,
    elevation:0
  },appBar: {
    position: 'relative',
  },title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  }
}));


 function BusLocationReport() {
  const classes = useStyles1();

  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [reportsMessage,setReportsMessage]=useState("Loading...");
  const [reportTitle,setReportTitle]=useState("Bus Daily report");

  const [currency,setCurrency]=useState("");

  const history = useHistory();


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const [activePark, setActivePark] =useState(null);
  const [pos1,setPos1]=useState(null);
  const [pos2,setPos2]=useState(null);
  const [message,setMessage]=useState("");




 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setOperatorData(data);

  get_coordinates(data.token);

 
},[]);


// load coordinates 


const [coordinates,setCoordinates]=useState([]);

const [coordinateLoad,setCoordinateLoad]=useState(false);


const get_coordinates=(token)=>{

 setCoordinateLoad(true);

 axios.defaults.baseURL = new ReportingService().BASE_URL;
 const coordinateInstance = axios.create(new ReportingService().setHeaders(token));
 coordinateInstance.post('/traffic-report/bus-locations',{
   "organization_id": new UserInfo().ORG_ID,
   "day": format(new Date(), ["yyyy-MM-dd"]),
   "vehicle": ""
})


 .then(res=>{
   
   var objs=res.data.data;
  
   console.log("coordinates",objs);
   
   var data=[];
   
 var groupByPlate = groupBy(objs, function(item) {
   return [item.vehicle];
});


groupByPlate.map((o)=>{
var len=o.length;
data.push(o[len-1]);
});

setCoordinates(data);

   setCoordinateLoad(false);
 })
 .catch(err=>{
   setCoordinateLoad(false);
 });

}

const L = require('leaflet');
const myIcon = L.icon({
   iconUrl: require('../../assets/svg/icon-bus.svg'),
   iconSize: [30,30],
   iconAnchor: [15, 30],
   popupAnchor: null,
   shadowUrl: null,
   shadowSize: null,
   shadowAnchor: null
});




  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><MapI fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Bus Location Report</b></Typography>

 </Box>

 <Button 
 disabled={coordinateLoad}
color="primary" 
variant="outlined"
startIcon={<Cached />}
onClick={()=>{
 get_coordinates(operatorData.token); 
}}
>
 {coordinateLoad==true?"Refreshing":"Refresh"}    
</Button>

</Box>


<Box mt={2}>

<Paper className={classes.paper2} elevation={0}>
            <Box display="flex" ml={3} justifyItems={"center"}>
              <Typography color="textSecondary">Bus Location Tracking</Typography>
            </Box>
            <Box  mt={2} ml={1} mr={1} >
              
          <Map center={[-1.992819,30.044063]} zoom={12}>

          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />

         

          {coordinates.map((c)=>{
            return (<Marker
              position={[c.latitude,c.longitude]}
              onClick={() => {
                setMessage("Bus : "+c.vehicle+"  Validator : "+c.validator);
                setPos1(c.latitude);
                setPos2(c.longitude);
                setActivePark(true);
              }}

              icon={myIcon}

            />);
          })}

        {/* <Marker
          position={[-1.992819,30.044063]}
          onClick={() => {
            setMessage("Matunda (Nyabugogo-Muhanga)");
            setPos1(-1.992819);
            setPos2(30.044063);
            setActivePark(true);
          }}
        /> */}

        {/* <Marker position={[-1.953377, 30.062118]}
        onClick={() => {
          setMessage("RITCO (Nyabugogo-Huye)");
          setPos1(-1.953377);
          setPos2(30.062118);
          setActivePark(true);
        }}
        /> */}

        {/* <Marker position={[-1.965280, 30.059612]}
        onClick={() => {
          setMessage("Yahoo (Nyabugogo-Rusizi)");
          setPos1(-1.965280);
          setPos2(30.059612);
          setActivePark(true);
        }}
        /> */}

      {activePark && (
        <Popup
          position={[pos1,pos2]}
          onClose={() => {
            setActivePark(null);
          }}
        >
          <div>
            <h2>Bus Details</h2>
            <p>{message}</p>
          </div>
        </Popup>
      )}
          </Map>
           </Box>
          </Paper>

</Box> 

 </div>

  
 </MuiPickersUtilsProvider>
  );
}

export default withLocalize(BusLocationReport);